import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Tip } from '../../../class/tip';
import { TipService } from '../../../service/tip/tip.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-tip',
  templateUrl: './new-tip.component.html',
  styleUrls: ['./new-tip.component.scss']
})
export class NewTipComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Tip;
    public promiseForm: Promise<any>;
    public form: FormGroup;

    public title: AbstractControl;
    public information: AbstractControl;
    public es: any;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public tipService: TipService,
        public translate: TranslateService,
        private notificationsService: NotificationsService) {

        this.save_exit = false;

        this.es = calendarES();

        this.form = fb.group({
            'title': ['', Validators.compose([Validators.required])],
            'information': ['', Validators.compose([Validators.required])],
        });


        this.title = this.form.controls['title'];
        this.information = this.form.controls['information'];
    }

    ngOnInit() {
        if (this.edit) {
            this.title.setValue(this.edit.title);
            this.information.setValue(this.edit.information);
        } else {
            // this.activated.setValue(true);
        }
    }

    public cancelTip () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }


    public saveandexit (values){
        this.save_exit = true;
        this.newTip(values);
    }

    public newTip(values) {
        const param = {
            'title': values.title,
            'information': values.information,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.tipService.updateTip(this.edit.id, param)
                :
                this.tipService.newTip(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    // public formatDate(date) {
    //     const d = new Date(date);
    //     let month = '' + (d.getMonth() + 1);
    //     let day = '' + d.getDate();
    //     const year = d.getFullYear();
    //     let hours = '' + d.getHours();
    //     let minutes = '' + d.getMinutes();
    //     let seconds = '' + d.getSeconds();

    //     if (month.length < 2) {
    //         month = '0' + month;
    //     }
    //     if (day.length < 2) {
    //         day = '0' + day;
    //     }

    //     if (hours.length < 2) {
    //         hours = '0' + hours;
    //     }

    //     if (minutes.length < 2) {
    //         minutes = '0' + minutes;
    //     }

    //     if (seconds.length < 2) {
    //         seconds = '0' + seconds;
    //     }

    //     return [year, month, day].join('-');
    // }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/tips/new-tip/new-tip.component.ts